import { render, staticRenderFns } from "./nodeWrap.vue?vue&type=template&id=28936b9d&"
import script from "./nodeWrap.vue?vue&type=script&lang=js&"
export * from "./nodeWrap.vue?vue&type=script&lang=js&"
import style0 from "./nodeWrap.vue?vue&type=style&index=0&id=28936b9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports